import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ContentCardModule } from '@app/library/content-card/content-card.module';
import { LibraryElementsModule } from '@app/library/library-elements.module';
import { NoContentStubComponent } from '@core/components/no-content-stub/no-content-stub.component';
import { PaginationModule } from '@core/components/pagination/pagination.module';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '@shared/icon/icon.component';
import { ClassroomContentPageComponent } from './classroom-content-page.component';
import { FeedPostFormComponent } from "../../../feed/feed-post-form/feed-post-form.component";

@NgModule({
  imports: [
    CommonModule,
    LibraryElementsModule,
    PaginationModule,
    TranslateModule,
    IconComponent,
    NoContentStubComponent,
    ContentCardModule,
    FeedPostFormComponent
],
  declarations: [ClassroomContentPageComponent],
  exports: [ClassroomContentPageComponent],
})
export class ClassroomContentPageModule {}
